import client from './client';

export const listNotes = (params) => client.get('/notes', { params }).then((r) => r.data);
export const createNote = (payload) => client.post('/notes', payload).then((r) => r.data);
export const updateNote = (id, payload) => client.put(`/notes/${id}`, payload).then((r) => r.data);
export const removeNote = (id) => client.delete(`/notes/${id}`).then((r) => r.data);
